import { translate } from 'utils/translate';

export const getAddressLabel = (addressQuantinty: number) => {
   const pluralRules = new Intl.PluralRules('pl-PL');
   const grammaticalNumber = pluralRules.select(addressQuantinty);
   switch (grammaticalNumber) {
      case 'one':
         return translate('labels.address_one');
      case 'few':
         return translate('labels.address_few');
      case 'many':
         return translate('labels.address_many');
   }
};
